import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import {  message ,Select } from 'antd';

import Foot from '../../components/foot/Foot'
import NumberFormat from 'react-number-format'


import { useTranslation } from 'react-i18next'

import './tan.css'
import {getLiushuiFegwPool} from "../../api";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexFegwPool = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [classesList,setClassesList]=useState([])
    const [page,setPage]=useState(1)


    const _getNewClassess = (e) =>{

         _getLiushuiCcer(e)
    }


    const _getLiushuiCcer = (c) =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getLiushuiFegwPool({classes:c,page:page}).then(res=>{
            if(res.code === 0 ){

                if(res.data.classesList != null){
                    setClassesList(res.data.classesList)
                }


                    setList(res.data.list || [])


            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }





    useEffect(() => {
            window.scrollTo(0, 0)
            _getLiushuiCcer(999)
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            
            <div className=' bg-[#F5F3F2] w-full lg:w-1/3 pb-20  pt-20 text-white flex flex-col z-10'>
                <div onClick={()=>window.history.back()} className='w-full h-12 px-4 flex flex-row justify-start items-center'>
                    <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-xs text-gray-500'>{t('share.返回')}</span>
                </div>
                {/*  */}
                <div className=' bg-[#F8FAFC] mt-5 mx-4 px-4 pt-6 pb-6 rounded-xl flex flex-col items-start border border-gray-200'>
                    
                    <span className='mb-4 mt-2 text-xl text-gray-800'>FEG-W {t('head.矿池')} {t('r.历史记录')}</span>
                    <div className='w-full mb-4'>
                        <Select
                        size='large'
                            defaultValue="所有类型"
                            style={{
                                width: "100%"
                            }}
                            onChange={_getLiushuiCcer}
                            options={classesList}
                            />
                    </div>
                    <span className='mb-3 text-xs text-[#0042bd] fontM'>No data</span>
                    <div className=' w-full h-[1px] bg-gray-100'></div>
                    {/*  */}
                    {
                        list.length>0?
                            list.map((item,index)=> {
                                return (
                                    <>
                                        <div className='mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                            <div className=' w-full flex flex-row justify-between items-center'>
                                                <div className=' text-gray-500 text-xs flex flex-row'>
                                                    <span>{item.classname}</span>
                                                </div>
                                                <div className=' text-gray-500 text-xs flex flex-row'>
                                                    <img alt='rr' className=' mr-1' src={require('../../assets/img/logo.png')} style={{"width":"15px"}}></img>
                                                    {
                                                        item.value>0?(
                                                            <span className='text-green-500'>+<NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={item.value}
                                                                            prefix=""
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={false}
                                                                            decimalScale={6} /></span>
                                                        ):(
                                                            <span className='text-red-500'>-<NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={item.value}
                                                                            prefix=""
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={false}
                                                                            decimalScale={6} /></span>
                                                        )
                                                    }
                                                    
                                                </div>
                                                
                                            </div>
                                            <div className='mt-2 w-full flex flex-row justify-between items-center'>
                                                <div className=' text-gray-500 text-xs flex flex-row'>
                                                    
                                                    <span>MEMO.</span>
                                                </div>
                                                <span className='text-xs text-gray-300 block'>{item.add_time}</span>
                                            </div>
                                            
                                        </div>
                                        <div className=' w-full h-[1px] my-2 bg-gray-100'></div>
                                    </>
                                )
                            }):(
                                <div  className=' w-full  py-32 flex flex-row items-center justify-center text-gray-200 text-xs'>
                                    No data
                                </div>
                            )
                    }
                    
                    {/*  */}
                    
                    
                </div>
                {/*  */}

                



            </div>
            
           

         <Foot/>           
        </>
    );
}

export default connect(mapStateToProps)(IndexFegwPool);
